import React, { memo } from 'react';
import { Alert, DialogContent, Typography } from '@mui/material';
import { useStackModalContext } from '../context/StackModalContext';
import StackModalForm from './StackModalForm';

interface StackModalContentProps {
  isLoading: boolean;
}

/**
 * Component for rendering the content of the stack modal
 */
const StackModalContent: React.FC<StackModalContentProps> = ({ isLoading }) => {
  const {
    state: { alertMessage },
  } = useStackModalContext();

  return (
    <DialogContent dividers>
      {alertMessage && (
        <Alert severity='error' sx={{ mb: 2 }}>
          {alertMessage}
        </Alert>
      )}
      {isLoading ? (
        <Typography>Loading stack data...</Typography>
      ) : (
        <StackModalForm />
      )}
    </DialogContent>
  );
};

export default memo(StackModalContent);
